import {BaseFactory} from "../../../../../infrastructure/factories/base-factory";
import {RateOptionDomainModel} from "../models/rate-option.domain-model";
import {RateOptionViewModel} from "../models/rate-option.view-model";
import {RateOptionApiModel} from "../models/rate-option.api-model";
import {ODDS_TYPES} from "../../../../../core/components/odds/components/odds-consts";

export class RateOptionFactory extends BaseFactory {
  static injectables = [...BaseFactory.injectables];

  createDomainModel(apiModel: RateOptionApiModel): RateOptionDomainModel {
    const domain: RateOptionDomainModel = new RateOptionDomainModel(apiModel);

    return domain;
  }

  createVM(model: RateOptionDomainModel,oddsType: ODDS_TYPES, count: Number): RateOptionViewModel {
    const vm: RateOptionViewModel = new RateOptionViewModel(model, oddsType, count);

    return vm;
  }
}
